import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  FaGlobe,
  FaCog,
  FaChartLine,
  FaUsers,
  FaClock,
  FaAward,
  FaRocket,
  FaArrowRight,
  FaStar,
  FaNetworkWired,
  FaEye,
  FaBullseye,
  FaHeart,
  FaShieldAlt,
  FaLightbulb,
  FaHandshake,
  FaLeaf,
  FaBuilding,
  FaCertificate,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import "./ONasPage.css";

const ONasPage = () => {
  const [activeTab, setActiveTab] = useState("story");
  const timelineRef = useRef(null);

  const yearsInBusiness = new Date().getFullYear() - 1989;

  const scrollTimeline = (direction) => {
    if (timelineRef.current) {
      const scrollAmount = 340;
      timelineRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stats = [
    { value: "1989", label: "Rok založenia" },
    { value: "500+", label: "Spokojných klientov" },
    { value: `${yearsInBusiness}+`, label: "Rokov skúseností" },
    { value: "100%", label: "Zákazkové riešenia" },
  ];

  const mission = {
    vision:
      "Našou víziou je byť dlhodobým a spoľahlivým partnerom v oblasti digitalizácie podnikania. Už od svojho vzniku v roku 1989 a transformácie na spoločnosť s ručením obmedzeným v roku 1993 budujeme renomé firmy, ktorá spája odbornosť, inovatívne myslenie a rýchlu implementáciu riešení.",
    mission:
      "Medzi naše hlavné náplne činnosti patrí vývoj informačných systémov na mieru, zabezpečenie hardwarového pozadia pre jeho beh, predaj hardware podľa požiadaviek zákazníka, webhostingové služby a špeciálne služby podľa potreby zákazníkov.",
    values:
      "Firma INVER je počtom ľudí menšia, dynamická firma ktorá je vďaka tomu schopná veľmi promptne reagovať na nadštandardné požiadavky zákazníkov a zameriava sa najmä na región Košíc a východného Slovenska.",
  };

  const companyValues = [
    {
      icon: FaShieldAlt,
      title: "Bezpečnosť a spoľahlivosť",
      description:
        "Zabezpečujeme najvyššiu úroveň ochrany dát a systémov našich klientov s 99.9% uptime garanciou.",
    },
    {
      icon: FaLightbulb,
      title: "Inovácie a technológie",
      description:
        "Sledujeme najnovšie trendy a implementujeme pokročilé technológie pre efektívne riešenia.",
    },
    {
      icon: FaHandshake,
      title: "Partnerstvo a dôvera",
      description:
        "Budujeme dlhodobé partnerstvá založené na vzájomnej dôvere a transparentnej komunikácii.",
    },
    {
      icon: FaHeart,
      title: "Zákaznícky prístup",
      description:
        "Potreby našich klientov sú na prvom mieste. Poskytujeme personalizované riešenia a 24/7 podporu.",
    },
    {
      icon: FaRocket,
      title: "Rast a rozvoj",
      description:
        "Neustále sa vzdelávame a rozvíjame, aby sme mohli ponúkať tie najlepšie služby a riešenia.",
    },
    {
      icon: FaLeaf,
      title: "Udržateľnosť",
      description:
        "Zodpovedne pristupujeme k životnému prostrediu a podporujeme ekologické IT riešenia.",
    },
  ];

  const milestones = [
    {
      year: "1989",
      title: "Založenie spoločnosti",
      description:
        "Firma INVER bola založená s cieľom vývoja programového vybavenia pre podvojné účtovníctvo.",
      icon: FaBuilding,
    },
    {
      year: "1993",
      title: "Transformácia na s.r.o.",
      description:
        "Spoločnosť sa pretransformovala do formy spoločnosti s ručením obmedzeným.",
      icon: FaCertificate,
    },
    {
      year: "1995",
      title: "Systém HERKULES",
      description:
        "Spustenie vlastného informačného systému HERKULES pre podvojné účtovníctvo.",
      icon: FaRocket,
    },
    {
      year: "2000",
      title: "Rozšírenie služieb",
      description:
        "Pridanie webhostingu a konzultačných služieb do portfólia spoločnosti.",
      icon: FaGlobe,
    },
    {
      year: "2005",
      title: "Špecializované moduly",
      description:
        "Vývoj modulov Špedícia a Predajňa pre špecifické potreby klientov.",
      icon: FaAward,
    },
    {
      year: "2010",
      title: "Moderné technológie",
      description:
        "Migrácia na Windows platformu a zavedenie vzdialených služieb cez internet.",
      icon: FaLightbulb,
    },
    {
      year: "2025",
      title: "Pokračujúca inovácia",
      description:
        `Už ${new Date().getFullYear() - 1989} rokov spoľahlivých služieb pre firmy na Slovensku a v Čechách.`,
      icon: FaAward,
    },
  ];

  const references = [
    {
      name: "Quehenberger Logistics GmbH",
      industry: "Logistika",
      rating: 5,
      logo: "/quehenberger.png",
    },
    {
      name: "CROCODILLE ČR s.r.o.",
      industry: "Potravinárstvo",
      rating: 5,
      logo: "/crocodille.webp",
    },
    {
      name: "PIKARO TRADING, SE",
      industry: "Hutníctvo",
      rating: 5,
      logo: "/pikaro-logo-web-03.png",
    },
    {
      name: "IQ servis, a.s.",
      industry: "Služby",
      rating: 5,
      logo: "/iq_servis.jpg",
    },
    { name: "EGYM, s.r.o.", industry: "Fitness", rating: 5, logo: "/egym.png" },
    {
      name: "Imuna Pharm, a.s.",
      industry: "Farmácia",
      rating: 5,
      logo: "/imuna.jpg",
    },
  ];

  const certifications = [
    {
      id: 1,
      name: "TP-Link Partner",
      logo: "TP-Link",
      description: "Certifikovaný partner pre profesionálne sieťové riešenia",
      technologies: ["Business WiFi", "Omada SDN", "Switches"],
      color: "#0066cc",
    },
    {
      id: 2,
      name: "MikroTik Certified",
      logo: "MikroTik",
      description: "Pokročilé routing a firewall konfigurácie",
      technologies: ["RouterOS", "MPLS", "VPN"],
      color: "#293893",
    },
    {
      id: 3,
      name: "Sieťové protokoly",
      logo: "Network",
      description: "Komplexná správa sieťovej infraštruktúry",
      technologies: ["VLAN", "WLAN", "DNS", "DHCP"],
      color: "#667eea",
    },
  ];

  return (
    <div className="o-nas-page">
      {/* Hero Section */}
      <section className="o-nas-hero">
        <h1>O nás</h1>
        <div className="hero-stats">
          {stats.map((stat, index) => (
            <div key={index} className="hero-stat">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <div className="mission-tabs">
              <button
                className={`tab ${activeTab === "story" ? "active" : ""}`}
                onClick={() => setActiveTab("story")}
              >
                <FaEye />
                Naša vízia
              </button>
              <button
                className={`tab ${activeTab === "mission" ? "active" : ""}`}
                onClick={() => setActiveTab("mission")}
              >
                <FaBullseye />
                Naše poslanie
              </button>
              <button
                className={`tab ${activeTab === "values" ? "active" : ""}`}
                onClick={() => setActiveTab("values")}
              >
                <FaHeart />
                Naše hodnoty
              </button>
            </div>

            <div className="mission-text">
              {activeTab === "story" && (
                <div className="tab-content">
                  <h3>Naša vízia</h3>
                  <p>{mission.vision}</p>
                </div>
              )}
              {activeTab === "mission" && (
                <div className="tab-content">
                  <h3>Naše poslanie</h3>
                  <p>{mission.mission}</p>
                </div>
              )}
              {activeTab === "values" && (
                <div className="tab-content">
                  <h3>Naše hodnoty</h3>
                  <p>{mission.values}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-us">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>Naša história a vízia</h2>
              <p>
                Firma INVER, založená v roku 1989 a transformovaná do s.r.o. v
                roku 1993, sa špecializuje na vývoj vlastných informačných
                systémov ako HERKULES, ŠPEDÍCIA, ZÁLOŽŇA a poskytovanie
                komplexných IT služieb. Naša hlavná výhoda spočíva v pružnosti a
                schopnosti sa rýchlo prispôsobiť konkrétnym potrebám zákazníka.
                Poskytujeme nielen softvérové riešenia, ale aj služby v oblasti
                sietí, hardware a ďalej služby ako webhosting, VPS hosting a
                konzultácie pre dlhodobú podporu a úspešný rozvoj vášho biznisu.
              </p>
              <div className="service-highlights">
                <div className="highlight-item">
                  <FaCog />
                  <div>
                    <h4>Zákazkové riešenia</h4>
                    <p>Vývoj softvéru "ušitého" na mieru vašim potrebám</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <FaClock />
                  <div>
                    <h4>Rýchla odozva</h4>
                    <p>Servisná podpora do 24 hodín na východnom Slovensku</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <FaGlobe />
                  <div>
                    <h4>Vzdialená podpora</h4>
                    <p>Okamžité riešenie problémov cez internet</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="about-stats">
              <div className="stat-item">
                <span className="stat-number">1989</span>
                <span className="stat-label">Rok založenia</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">{yearsInBusiness}+</span>
                <span className="stat-label">Rokov skúseností</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">24h</span>
                <span className="stat-label">Servisná odozva</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <h2>Čo nás charakterizuje</h2>
            <p>Hodnoty, ktoré nás vedú a formujú našu firemnú kultúru</p>
          </div>
          <div className="values-grid">
            {companyValues.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">
                  <value.icon />
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="timeline-section">
        <div className="container">
          <div className="section-header">
            <h2>Naša história</h2>
            <p>Kľúčové míľniky na ceste k úspechu</p>
          </div>
          <div className="timeline-slider-wrapper">
            <button className="timeline-nav timeline-nav-left" onClick={() => scrollTimeline('left')} aria-label="Posunúť doľava">
              <FaChevronLeft />
            </button>
            <div className="timeline-slider" ref={timelineRef}>
              {milestones.map((milestone, index) => (
                <div key={index} className="timeline-card">
                  <div className="timeline-card-year">
                    <milestone.icon />
                    <span>{milestone.year}</span>
                  </div>
                  <div className="timeline-card-line"></div>
                  <h3>{milestone.title}</h3>
                  <p>{milestone.description}</p>
                </div>
              ))}
            </div>
            <button className="timeline-nav timeline-nav-right" onClick={() => scrollTimeline('right')} aria-label="Posunúť doprava">
              <FaChevronRight />
            </button>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="trust-section">
        <div className="container">
          <div className="trust-content">
            <div className="trust-text">
              <h2>Viac ako 500 spokojných klientov</h2>
              <p>
                Už viac ako {yearsInBusiness} rokov poskytujeme kvalitné IT
                riešenia firmám na východnom Slovensku. Naši klienti si nás
                vybrali pre našu spoľahlivosť, profesionalitu a schopnosť
                vyriešiť ich špecifické potreby.
              </p>
              <div className="trust-stats">
                <div className="trust-stat">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Spokojných klientov</div>
                </div>
                <div className="trust-stat">
                  <div className="stat-number">{yearsInBusiness}+</div>
                  <div className="stat-label">Rokov skúseností</div>
                </div>
                <div className="trust-stat">
                  <div className="stat-number">100%</div>
                  <div className="stat-label">Zákazkové riešenia</div>
                </div>
              </div>
            </div>
            <div className="clients-showcase">
              <h3>Vybrané referencie</h3>
              <div className="clients-list">
                {references.map((reference, index) => (
                  <div key={index} className="client-item">
                    <div className="client-logo">
                      {reference.logo ? (
                        <img src={reference.logo} alt={reference.name} />
                      ) : (
                        <span>{reference.name.charAt(0)}</span>
                      )}
                    </div>
                    <div className="client-details">
                      <h4>{reference.name}</h4>
                      <span className="client-industry">
                        {reference.industry}
                      </span>
                    </div>
                    <div className="client-rating">
                      {[...Array(reference.rating)].map((_, i) => (
                        <FaStar key={i} />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <Link to="/referencie" className="btn btn-outline">
                Zobraziť všetky referencie <FaArrowRight />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Network Certifications Section */}
      <section className="network-certifications">
        <div className="container">
          <div className="section-header">
            <h2>Naše certifikácie a technológie</h2>
            <p>
              Specializujeme sa na sieťové riešenia s oficiálnymi certifikáciami
            </p>
          </div>
          <div className="certifications-grid">
            {certifications.map((cert) => (
              <div key={cert.id} className="cert-card">
                <div className="cert-logo">
                  {cert.logo === "Network" ? (
                    <FaNetworkWired className="network-icon" />
                  ) : (
                    <div
                      className={`${cert.logo.toLowerCase()}-logo`}
                      style={{ color: cert.color }}
                    >
                      {cert.logo}
                    </div>
                  )}
                </div>
                <h4>{cert.name}</h4>
                <p>{cert.description}</p>
                <div className="cert-technologies">
                  {cert.technologies.map((tech, idx) => (
                    <span
                      key={idx}
                      className="tech-tag"
                      style={{ backgroundColor: cert.color }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ONasPage;
